import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { multiPolygonSchema, polygonSchema } from "../geojson";
import { paginatedSchema } from "../pagination";

import { baseAssetWithTimeseriesSchema } from "./assetsBase";

export const fixedDrainageLevelAreaListItemSchema = baseAssetWithTimeseriesSchema.extend({
  geometry: polygonSchema.or(multiPolygonSchema),
  name: z.string(),
  type: z.string(),
  water_level_summer: z.number().nullable(),
  water_level_winter: z.number().nullable(),
  water_level_fixed: z.number().nullable(),
});

export type FixedDrainageLevelAreaListItem = z.infer<typeof fixedDrainageLevelAreaListItemSchema>;

export const fixedDrainageLevelAreaListSchema = paginatedSchema(
  fixedDrainageLevelAreaListItemSchema
);
export type FixedDrainageLevelAreaList = z.infer<typeof fixedDrainageLevelAreaListSchema>;

export const fixedDrainageLevelAreaSchema = fixedDrainageLevelAreaListItemSchema;
export type FixedDrainageLevelArea = z.infer<typeof fixedDrainageLevelAreaSchema>;

export function useFixedDrainageLevelAreas(params = {}) {
  const url = combineUrlAndParams("/api/v4/fixeddrainagelevelareas/", params);
  return useParsedQuery<FixedDrainageLevelAreaList>(
    ["lizard-api-v4", "fixeddrainagelevelareas", url],
    () => fetchWithError(url),
    (json: unknown) => fixedDrainageLevelAreaListSchema.parse(json)
  );
}

export function useFixedDrainageLevelArea(id: number) {
  return useParsedQuery<FixedDrainageLevelArea>(
    ["lizard-api-v4", "fixeddrainagelevelareas", id],
    () => fetchWithError(`/api/v4/fixeddrainagelevelareas/${id}/`),
    (json: unknown) => fixedDrainageLevelAreaSchema.parse(json)
  );
}

export function useMultipleFixedDrainageLevelAreas(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "fixeddrainagelevelareas", id],
        fetchFunction: () => fetchWithError(`/api/v4/fixeddrainagelevelareas/${id}/`),
        parseFunction: (json: unknown) => fixedDrainageLevelAreaSchema.parse(json),
      };
    })
  );
}
